import { render, staticRenderFns } from "./EditionNogaBranches.vue?vue&type=template&id=09ccbd85&scoped=true"
import script from "./EditionNogaBranches.vue?vue&type=script&lang=js"
export * from "./EditionNogaBranches.vue?vue&type=script&lang=js"
import style0 from "./EditionNogaBranches.vue?vue&type=style&index=0&id=09ccbd85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ccbd85",
  null
  
)

export default component.exports